export default "__VITE_ASSET__BAZdQRiI__"